import { render } from "./answerSheet.vue?vue&type=template&id=58d1ff10&scoped=true"
import script from "./answerSheet.vue?vue&type=script&lang=js"
export * from "./answerSheet.vue?vue&type=script&lang=js"

import "./answerSheet.vue?vue&type=style&index=0&id=58d1ff10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d1ff10"]])

export default __exports__